import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconsModule } from 'src/app/icons/icons.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SidenavHeaderModule } from '../sidenav-header/sidenav-header.module';
import { NotificationCardComponent } from './notification-card/notification-card.component';
import { NotificationsListComponent } from './notifications-list/notifications-list.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    NotificationCardComponent,
    NotificationsListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    SidenavHeaderModule,
    RouterModule,
    MatDialogModule
  ],
  exports: [
    NotificationCardComponent,
    NotificationsListComponent
  ]
})
export class NotificationsModule { }
